const AdminCommissionModal = ({
    setShowAdminCommissionModal,
    adminCommission,
    setAdminCommission,
    isAdminCommissionLoading,
    handleSaveAdminCommission
}) => {

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal !w-[400px]">

                <div className="custom-modal-header">
                    <h4>Admin Commission</h4>
                    <button
                        className="close-btn"
                        onClick={() => setShowAdminCommissionModal(false)}
                    >
                        ×
                    </button>
                </div>

                <div className="custom-modal-body">
                    <div className="form-section">
                        <div className="form flex align-center gap-3 flex-wrap">
                            <div className="form-group" key="incity">

                                <label>Admin Commission </label>
                                <input
                                    type="number"
                                    name="commission"
                                    value={adminCommission}
                                    onChange={(e) => setAdminCommission(e.target.value)}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="custom-modal-footer">
                    <button className="btn btn-dark"
                        onClick={() => setShowAdminCommissionModal(false)}>
                        Cancel
                    </button>

                    <button
                        className="btn btn-success"
                        onClick={handleSaveAdminCommission}
                        disabled={isAdminCommissionLoading}>
                        {isAdminCommissionLoading ? "saving...." : "Save Admin Commission"}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default AdminCommissionModal;